TransportValidator.$inject = ['validator'];

export default function TransportValidator(validator) {
    const instance = new validator();

    return instance;
}
